import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import styled from "styled-components";
import { FormGroup } from "./CostCalculadora";
import { EstiloButton, Alert, CloseButton } from "./App";
import { setDoc, collection, addDoc } from "firebase/firestore";
import { db } from "./Firebase";

const ContenedorFormBase = styled.div`
  margin: auto;
  margin-top: 1.5rem;
  text-align: center;
  width: 380px;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 330px;
  }
`;
const FormDiv = styled.div`
  margin-bottom: 3rem;
  p {
    margin: 0px;
  }
`;
const ContenedorText = styled.div`
  width: 100%;
  textarea {
    width: 100%;
    background-color: #f0f0f0; /* Color de fondo */
    color: #333; /* Color del texto */
    border: 1px solid #ccc; /* Color del borde */
    padding: 10px; /* Espaciado interno */
  }
`;

const ContratoForm = ({ generarContrato }) => {
  const [mostrarInput, setMostrarInput] = useState(false);
  const [contratoNumero, setContratoNumero] = useState(uuidv4());
  const [camposFaltantes, setCamposFaltantes] = useState([]);
  const [formData, setFormData] = useState({
    emailCliente: "",
    empresaFactura: "",
    fecha: "",
    nombreApellido: "",
    dni: "",
    tipoBus: "",
    pisos: "",
    butacas: "",
    elementosConfort: "",
    fechaSalida: "",
    horaSalida: "",
    origen: "",
    destino: "",
    fechaRegreso: "",
    horaRegreso: "",
    kmEnDestino: "",
    tipoDeServicio: "",
    kmCotizados: "",
    tarifaTotal: "",
    montoEnLetras: "",
    formaDePago: "",
    comprobanteDePago: "",
    montoPagare: "",
    observaciones: "",
    servicioMensual: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const closeAlert = () => setShowAlert(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleServicioChange = (e) => {
    const selectedServicio = e.target.value;
    setFormData((prev) => ({
      ...prev,
      servicio: selectedServicio,
      destino: selectedServicio === "receptivo" ? "receptivos" : "",
      kmEnDestino: selectedServicio === "receptivo" ? 0 : "",
    }));
  };

  const camposObligatorios = [
    "emailCliente",
    "empresaFactura",
    "fecha",
    "nombreApellido",
    "dni",
    "tipoBus",
    "butacas",
    "elementosConfort",
    "fechaSalida",
    "horaSalida",
    "tarifaTotal",
    "montoEnLetras",
    "formaDePago",
    "comprobanteDePago",
    "montoPagare",
    "servicioMensual",
  ];

  const validarCampos = () => {
    const camposFaltantes = camposObligatorios.filter(
      (campo) => !formData[campo]
    );
    setCamposFaltantes(camposFaltantes);
    return camposFaltantes.length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    if (!validarCampos()) {
      setShowAlert(true);
      setIsSubmitting(false);
      return;
    }

    try {
      const contratosRef = collection(db, "contratos");
      const docRef = await addDoc(contratosRef, {
        ...formData,
        pisos: formData.pisos ? "sí" : "no",
        contratoNumero,
      });

      await setDoc(docRef, {
        ...formData,
        pisos: formData.pisos ? "sí" : "no",
        contratoNumero,
        docId: docRef.id, // 🔥 Agrega el docId automático
      });

      console.log("Contrato guardado con ID:", docRef.id);

      generarContrato({
        ...formData,
        pisos: formData.pisos ? "sí" : "no",
        contratoNumero,
        docId: docRef.id,
      });

      // Limpiar formulario
      setContratoNumero(uuidv4());
      setFormData({
        emailCliente: "",
        empresaFactura: "",
        fecha: "",
        nombreApellido: "",
        dni: "",
        tipoBus: "",
        pisos: "",
        butacas: "",
        elementosConfort: "",
        fechaSalida: "",
        horaSalida: "",
        origen: "",
        destino: "",
        fechaRegreso: "",
        horaRegreso: "",
        kmEnDestino: "",
        tipoDeServicio: "",
        kmCotizados: "",
        tarifaTotal: "",
        montoEnLetras: "",
        formaDePago: "",
        comprobanteDePago: "",
        montoPagare: "",
        observaciones: "",
        servicioMensual: "",
      });
    } catch (error) {
      console.error("Error al guardar contrato:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ContenedorFormBase>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          <div>
            <strong>Por favor, complete los siguientes campos:</strong>
            <ul style={{ marginTop: "5px", marginBottom: 0 }}>
              {camposFaltantes.map((campo) => (
                <li key={campo}>
                  {campo
                    .replace(/([A-Z])/g, " $1") // separa palabras compuestas
                    .replace(/^./, (s) => s.toUpperCase())}{" "}
                  {/* capitaliza */}
                </li>
              ))}
            </ul>
          </div>
        </Alert>
      )}

      <h4>Contrato</h4>
      <FormDiv>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <label htmlFor="fecha">Fecha:</label>
            <input
              type="date"
              id="fecha"
              name="fecha"
              value={formData.fecha}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="empresaFactura">Empresa que factura:</label>
            <select
              id="empresaFactura"
              name="empresaFactura"
              value={formData.empresaFactura}
              onChange={handleChange}
            >
              <option value="">seleccione</option>
              <option value="cata">CATA Internacional</option>
              <option value="mitre">Mitre S.R.L.</option>
              <option value="tupungato">Autotransportes Tupungato S.A.</option>
            </select>
          </FormGroup>
          <FormGroup>
            <label htmlFor="nombreApellido">Nombre Cliente:</label>
            {!mostrarInput ? (
              <select
                id="nombreApellido"
                name="nombreApellido"
                value={formData.nombreApellido}
                onChange={(e) => {
                  const selected = e.target.value;
                  if (selected === "Ingrese un nombre") {
                    setMostrarInput(true);
                    setFormData((prev) => ({
                      ...prev,
                      nombreApellido: "",
                      dni: "",
                      emailCliente: "",
                    }));
                  } else if (selected === "CLUB ATLETICO GIMNASIA Y ESGRIMA") {
                    setFormData((prev) => ({
                      ...prev,
                      nombreApellido: selected,
                      dni: "30-67640243-4",
                      emailCliente: "yamicorrea@hotmail.com.ar",
                    }));
                  } else {
                    setFormData((prev) => ({
                      ...prev,
                      nombreApellido: selected,
                      dni: "",
                      emailCliente: "",
                    }));
                  }
                }}
              >
                <option value="">Seleccione</option>
                <option value="CLUB ATLETICO GIMNASIA Y ESGRIMA">
                  CLUB ATLETICO GIMNASIA Y ESGRIMA
                </option>
                <option value="Ingrese un nombre">Otro</option>
              </select>
            ) : (
              <input
                type="text"
                id="nombreApellido"
                name="nombreApellido"
                value={formData.nombreApellido}
                onChange={handleChange}
              />
            )}
          </FormGroup>

          {formData.nombreApellido === "CLUB ATLETICO GIMNASIA Y ESGRIMA" ? (
            <>
              <FormGroup>
                <label htmlFor="dni">DNI - CUIT:</label>
                <input
                  type="text"
                  id="dni"
                  name="dni"
                  value={formData.dni}
                  onChange={handleChange}
                />
              </FormGroup>
              <p>El correo se utilizará para el envio del contrato.</p>
              <FormGroup>
                <label htmlFor="emailCliente">Email Cliente:</label>
                <input
                  type="email"
                  id="emailCliente"
                  name="emailCliente"
                  value={formData.emailCliente}
                  onChange={handleChange}
                />
              </FormGroup>
            </>
          ) : (
            <>
              <FormGroup>
                <label htmlFor="dni">DNI - CUIT:</label>
                <input
                  type="text"
                  id="dni"
                  name="dni"
                  value={formData.dni}
                  onChange={handleChange}
                />
              </FormGroup>
              <p>El correo se utilizará para el envio del contrato.</p>
              <FormGroup>
                <label htmlFor="emailCliente">Email Cliente:</label>
                <input
                  type="email"
                  id="emailCliente"
                  name="emailCliente"
                  value={formData.emailCliente}
                  onChange={handleChange}
                />
              </FormGroup>
            </>
          )}

          <FormGroup>
            <label htmlFor="tipoBus">Tipo de Bus:</label>
            <select
              id="tipoBus"
              name="tipoBus"
              value={formData.tipoBus}
              onChange={handleChange}
            >
              <option value="">seleccione</option>
              <option value="tipo MIX">tipo MIX</option>
              <option value="semicama">semicama</option>
              <option value="bus40">bus40</option>
              <option value="cama">cama</option>
              <option value="suite">suite</option>
              <option value="según disponibilidad">según disponibilidad</option>
            </select>
          </FormGroup>
          <FormGroup>
            <label htmlFor="pisos">Uno o dos pisos:</label>
            <select
              id="pisos"
              name="pisos"
              value={formData.pisos}
              onChange={handleChange}
            >
              <option value="">seleccione</option>
              <option value="un piso">un piso</option>
              <option value="dos pisos">dos pisos</option>
            </select>
          </FormGroup>
          <FormGroup>
            <label htmlFor="butacas">Cantidad de butacas:</label>
            <input
              type="number"
              id="butacas"
              name="butacas"
              value={formData.butacas}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="elementosConfort">Confort:</label>
            <select
              id="elementosConfort"
              name="elementosConfort"
              value={formData.elementosConfort}
              onChange={handleChange}
            >
              <option value="">seleccione</option>
              <option value="AIRE/CALEFACCION/AUDIO">
                AIRE/CALEFACCION/AUDIO
              </option>
              <option value="si">varios</option>
              <option value="no">no</option>
            </select>
          </FormGroup>
          <FormGroup>
            <label htmlFor="fechaSalida">Salida / Inicio:</label>
            <input
              type="date"
              id="fechaSalida"
              name="fechaSalida"
              value={formData.fechaSalida}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="horaSalida">Hora:</label>
            <input
              type="time"
              id="horaSalida"
              name="horaSalida"
              value={formData.horaSalida}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="servicio">Tipo de Servicio:</label>
            <select
              id="servicio"
              name="servicio"
              value={formData.servicio}
              onChange={handleServicioChange}
            >
              <option value="">Seleccione un servicio</option>
              <option value="receptivo">Servicio Receptivo</option>
              <option value="especial">Servicio Especial</option>
            </select>
          </FormGroup>

          {formData.servicio === "receptivo" && (
            <>
              <FormGroup>
                <label htmlFor="origen">Ciudad / Lugar:</label>
                <input
                  type="text"
                  id="origen"
                  name="origen"
                  value={formData.origen}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="fechaRegreso">Fecha de Finalización:</label>
                <input
                  type="date"
                  id="fechaRegreso"
                  name="fechaRegreso"
                  value={formData.fechaRegreso}
                  onChange={handleChange}
                />
              </FormGroup>
            </>
          )}

          {formData.servicio === "especial" && (
            <>
              <FormGroup>
                <label htmlFor="origen">Origen:</label>
                <input
                  type="text"
                  id="origen"
                  name="origen"
                  value={formData.origen}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="destino">Destino:</label>
                <input
                  type="text"
                  id="destino"
                  name="destino"
                  value={formData.destino}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="fechaRegreso">Fecha de Regreso:</label>
                <input
                  type="date"
                  id="fechaRegreso"
                  name="fechaRegreso"
                  value={formData.fechaRegreso}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="horaRegreso">Hora de Regreso:</label>
                <input
                  type="time"
                  id="horaRegreso"
                  name="horaRegreso"
                  value={formData.horaRegreso}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="kmEnDestino">Km permitidos en destino:</label>
                <input
                  type="number"
                  id="kmEnDestino"
                  name="kmEnDestino"
                  value={formData.kmEnDestino}
                  onChange={handleChange}
                />
              </FormGroup>
            </>
          )}

          {formData.nombreApellido === "CLUB ATLETICO GIMNASIA Y ESGRIMA" && (
            <>
              <FormGroup>
                <label htmlFor="tipoDeServicio">Tipo de Recorrido:</label>
                <select
                  id="tipoDeServicio"
                  name="tipoDeServicio"
                  value={formData.tipoDeServicio}
                  onChange={handleChange}
                >
                  <option value="">seleccione</option>
                  <option value="urbano">urbano</option>
                  <option value="larga distancia">larga distancia</option>
                  <option value="internacional">internacional</option>
                </select>
              </FormGroup>
              <p>km reales + km vacíos + 50km x día de estadía</p>
              <FormGroup>
                <label htmlFor="kmCotizados">Kilometros cotizados:</label>
                <input
                  type="number"
                  id="kmCotizados"
                  name="kmCotizados"
                  value={formData.kmCotizados}
                  onChange={handleChange}
                />
              </FormGroup>
            </>
          )}
          <FormGroup>
            <label htmlFor="tarifaTotal">Monto total del servicio:</label>
            <input
              type="number"
              id="tarifaTotal"
              name="tarifaTotal"
              value={formData.tarifaTotal}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="montoEnLetras">Monto en letras:</label>
            <input
              type="text"
              id="montoEnLetras"
              name="montoEnLetras"
              value={formData.montoEnLetras}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="formaDePago">Forma de Pago:</label>
            <select
              id="formaDePago"
              name="formaDePago"
              value={formData.formaDePago}
              onChange={handleChange}
            >
              <option value="">seleccione</option>
              <option value="tarjeta 1 pago">tarjeta 1 pago</option>
              <option value="tarjeta 2 pago">tarjeta 2 pago</option>
              <option value="tarjeta 3 pago">tarjeta 3 pago</option>
              <option value="tarjeta 4 pago">tarjeta 4 pago</option>
              <option value="tarjeta 5 pago">tarjeta 5 pago</option>
              <option value="tarjeta 6 pago">tarjeta 6 pago</option>
              <option value="transferencia">transferencia</option>
              <option value="mercado pago">mercado pago</option>
              <option value="cheque">cheque</option>
              <option value="efectivo">efectivo</option>
              <option value="canje">canje</option>
            </select>
          </FormGroup>
          <p>
            Ingrese el n° de comprobante, cupón de tarjeta, o detalle la forma
            de pago.
          </p>
          <FormGroup>
            <label htmlFor="comprobanteDePago">Comprobante de pago:</label>
            <input
              type="text"
              id="comprobanteDePago"
              name="comprobanteDePago"
              value={formData.comprobanteDePago}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="servicioMensual">Contrato 6 meses:</label>
            <select
              id="servicioMensual"
              name="servicioMensual"
              value={formData.servicioMensual}
              onChange={handleChange}
            >
              <option value="">seleccione</option>
              <option value="si">si</option>
              <option value="no">no</option>
            </select>
          </FormGroup>
          <FormGroup>
            <ContenedorText>
              <h6 style={{ margin: "0px" }}>
                Itinerario breve / Observaciones
              </h6>
              <textarea
                id="observaciones"
                name="observaciones"
                rows="10"
                value={formData.observaciones}
                onChange={handleChange}
              />
            </ContenedorText>
          </FormGroup>
          <FormGroup>
            <label htmlFor="montoPagare">Monto póliza:</label>
            <select
              id="montoPagare"
              name="montoPagare"
              value={formData.montoPagare}
              onChange={handleChange}
            >
              <option value="">seleccione</option>
              <option value="10% sobre el total del servicio presupuestado.">
                10%
              </option>
              <option value="15% sobre el total del servicio presupuestado.">
                15%
              </option>
              <option value="20% sobre el total del servicio presupuestado.">
                20%
              </option>
              <option value="25% sobre el total del servicio presupuestado.">
                25%
              </option>
            </select>
          </FormGroup>
          <EstiloButton type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Generando..." : "Generar Contrato"}
          </EstiloButton>
        </form>
      </FormDiv>
    </ContenedorFormBase>
  );
};

export default ContratoForm;
